import { useTranslation } from 'react-i18next';

export function useLanguage(): [string | null, (languageCode: string) => void] {
  const { i18n } = useTranslation();
  
  const language = i18n.language || null;
  
  const setLanguage = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };
  
  return [language, setLanguage];
}